import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-product-lib',
  template: `
    <p>
      product-lib works!
    </p>
  `,
  styles: []
})
export class ProductLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
